import { renderEditorMCQ } from "../MCQ";

const renderEditorReOrder = (block: any) => renderEditorMCQ(block, false);

export default renderEditorReOrder;
